module.exports = __webpack_public_path__ + "media/Indoor Fitness.b012877e.mp4";